import { api, unwrap } from "@lumberset/api-client";
import { queryOptions } from "@tanstack/react-query";

/** Staff management: the team with its numbers, and one Staff member's page. */

export const teamQuery = queryOptions({
  queryKey: ["admin", "team"],
  queryFn: () => unwrap(api.admin.team.$get()),
});

export const teamMemberQuery = (userId: string) =>
  queryOptions({
    queryKey: ["admin", "team", userId],
    queryFn: () => unwrap(api.admin.team[":userId"].$get({ param: { userId } })),
  });

/** The two ways an Admin settles a Staff member's unconfirmed email. */
export const teamEmailActions = {
  /** Answers with their updated profile. */
  confirm: (userId: string) =>
    unwrap(api.admin.team[":userId"]["confirm-email"].$post({ param: { userId } })),
  /** Answers with the address and the app the link opens. */
  sendConfirmation: (userId: string) =>
    unwrap(api.admin.team[":userId"]["send-confirmation"].$post({ param: { userId } })),
};

export type TeamList = Awaited<ReturnType<NonNullable<typeof teamQuery.queryFn>>>;
export type TeamPerson = TeamList["staff"][number];
export type TeamMember = Awaited<
  ReturnType<NonNullable<ReturnType<typeof teamMemberQuery>["queryFn"]>>
>;
export type WorkNumbers = TeamPerson["numbers"];
